import { render, staticRenderFns } from "./WbIcon.vue?vue&type=template&id=5c71d5f2&scoped=true"
import script from "./WbIcon.vue?vue&type=script&lang=js"
export * from "./WbIcon.vue?vue&type=script&lang=js"
import style0 from "./WbIcon.vue?vue&type=style&index=0&id=5c71d5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c71d5f2",
  null
  
)

export default component.exports